<template>
  <div style="margin-top: 250px">


    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("Julat Harga") }} {{ title }}
      </v-card-title>

      <v-container>
          <v-row>

            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('pusingan')"
                return-object
                :items="lookuppusingan"
                item-text="pusingan"
                v-model="pusingan"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field
                outlined
                dense
                v-bind:label="$t('Kod Item')"
                v-model="kodItem"
              ></v-text-field>
            </v-col>

             <v-col cols="9" sm="1">
             <v-btn
                    color="blue white white--text"
                    @click='cari()'>
                    <span class="material-icons">search</span> 
                   {{ $t("cari") }}</v-btn>
            </v-col>
            
          </v-row>
          
          <!-- <v-card-text>
            <v-card-title style="text-align: center" class="text-h7">
                <img
                  src="~@/assets/logojabatan.png"
                  alt="HIES/BA"
                  width="100"
                  height="100"
                />
              
                SISTEM SURVEI PENDAPATAN, PERBELANJAAN ISI RUMAH DAN KEMUDAHAN
                ASAS <br />
                RINGKASAN KADAR RESPON ISI RUMAH
            
                <img
                  src="~@/assets/HIES.jpg"
                  alt="HIES/BA"
                  width="100"
                  height="100"
                />

                    <v-col class="text-right">
                        <v-btn type="button" align="top-right" color="red white white--text" 
                          @click='exportPDF()'><span class='fas fa-file-pdf' style='font-size:24px'>&nbsp;&nbsp;</span>
                          {{ $t("muatturun") }} 
                        </v-btn>
                    </v-col>
                      &nbsp;&nbsp;
                    <v-col>
                      <v-btn type="button" color="green white white--text"
                          @click='exportExcel()'><span class='fas fa-file-excel' style='font-size:24px'>&nbsp;&nbsp;</span>
                          {{ $t("muatturun") }} 
                      </v-btn>
                    </v-col>
            </v-card-title>
          </v-card-text> -->
        
        <v-row>
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                color="deep-purple accent-4"
              ></v-progress-linear>
        </v-row>   
          <v-card-text>

            <v-simple-table fixed-header dense height="300px">
              <thead>
                <tr>
                  <th style="text-align:left;font-size: medium;"><strong>HID</strong></th>
                  <th style="text-align:left;font-size: medium;"><strong>Kod Item</strong></th>
                  <th style="text-align:left;font-size: medium;"><strong>RM Negeri</strong></th>
                  <th style="text-align:left;font-size: medium;"><strong>Kuantiti</strong></th>
                  <th style="text-align:left;font-size: medium;"><strong>Unit</strong></th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in dataJulatHarga" v-bind:key="item.index" @click="handleClick(item)">
                  <td>{{item.HID}}</td>
                  <td>{{item.KodItem}}</td>
                  <td>{{item.RMNEG}}</td>
                  <td>{{item.Kuantiti}}</td>
                  <td>{{item.Unit}}</td>
                </tr>
              </tbody>
  
            </v-simple-table>
          </v-card-text>
          
          <v-card-text>
              <h3>Detail Data</h3>
              <v-simple-table fixed-header dense >
                <thead>
                  <tr>
                    <th style="text-align:left;font-size: medium;"><strong>HID</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Tarikh</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Minggu</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Bil</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Kod Item</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Keterangan</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>RMHQ</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>RMNEGERI</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Punca Pembelian</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Jenis Barang</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Sebenar Anggaran</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Pembayaran</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Medium Bayaran</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>eDagang</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Catatan</strong></th>
                  </tr>
                </thead>

                <tbody>
                  <tr >
                    <td>{{detailData.HID}}</td>
                    <td>{{convertTarikh(detailData.Tarikh)}}</td>
                    <td>{{detailData.Minggu}}</td>
                    <td>{{detailData.Bil}}</td>
                    <td>{{detailData.KodItem}}</td>
                    <td>{{detailData.Keterangan}}</td>
                    <td>{{detailData.RMHQ}}</td>
                    <td>{{detailData.RMNEG}}</td>
                    <td>{{detailData.PuncaPembelian}}</td>
                    <td>{{detailData.JenisBarang}}</td>
                    <td>{{detailData.SebenarAnggaran}}</td>
                    <td>{{detailData.Pembayaran}}</td>
                    <td>{{detailData.MediumBayaran}}</td>
                    <td>{{detailData.eDagang}}</td>
                    <td>{{detailData.Catatan}}</td>
                  </tr>
                </tbody>
    
              </v-simple-table>
          </v-card-text>

          <v-card-text>
              <h3>Detail Data by HID</h3>
              <v-simple-table fixed-header dense height="400px">
                <thead>
                  <tr>
                    <th style="text-align:left;font-size: medium;"><strong>HID</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Tarikh</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Minggu</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Bil</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Kod Item</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Keterangan</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>RMHQ</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>RMNEGERI</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Punca Pembelian</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Jenis Barang</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Sebenar Anggaran</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Pembayaran</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Medium Bayaran</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>eDagang</strong></th>
                    <th style="text-align:left;font-size: medium;"><strong>Catatan</strong></th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in detailDataByHID" v-bind:key="item.index">
                    <td>{{detailData.HID}}</td>
                    <td>{{convertTarikh(detailData.Tarikh)}}</td>
                    <td>{{detailData.Minggu}}</td>
                    <td>{{detailData.Bil}}</td>
                    <td>{{detailData.KodItem}}</td>
                    <td>{{detailData.Keterangan}}</td>
                    <td>{{detailData.RMHQ}}</td>
                    <td>{{detailData.RMNEG}}</td>
                    <td>{{detailData.PuncaPembelian}}</td>
                    <td>{{detailData.JenisBarang}}</td>
                    <td>{{detailData.SebenarAnggaran}}</td>
                    <td>{{detailData.Pembayaran}}</td>
                    <td>{{detailData.MediumBayaran}}</td>
                    <td>{{detailData.eDagang}}</td>
                    <td>{{detailData.Catatan}}</td>
                  </tr>
                </tbody>
    
              </v-simple-table>
          </v-card-text>

      </v-container>
    </v-card>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();

export default {
  async beforeMount(){
   
  
},
  Name: "Kadarrespon",
  
  computed: {},
  setup() {},
  data: () => ({
    
    userDetail:'',
    loading: false,
    
    ///////////link untuk ke page/////////////////////
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: `paparanutama`,
      },
      {
        text: `${i18n.t("kadarrespon")}`,
        disabled: true,
        href: "",
      },
    ],
    title: "",
   
    lookupnegeri: [],
    sample: "",
    paparpusinganexport: "",
    lookuppusingan: [],
    lookupsample: [],
    sortedData:[],
    paparnegeriexport: "",
    disablepusingan: true,
    peranan: "",
    disablenegeri: true,
    disablesample: true,
    R:"",
    detailNegeri:"",

    kodItem: '',
    pusingan:'',
    dataJulatHarga:[],
    detailData:[],
    detailDataByHID:[],
    
  }),
  async mounted() {
    var listPusingan = await pusingan.getPusinganDataAll();
    this.lookuppusingan = listPusingan;

    this.lookupsample = await pusingan.getSample();

    this.$store.dispatch("localStorageuser");
    this.userDetail = this.$store.state.localStorageuser;

    // var listNegeri = await negerilookup.getNegeri();
    // this.lookupnegeri = listNegeri.data.data;

    //   for(var i =0;i<this.lookupnegeri.length;i++){
    //     if(this.lookupnegeri[i].negeriID == this.userDetail.kodneg){
    //       this.detailNegeri = this.lookupnegeri[i];
    //     }
    //   }

    
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}`;
},
     
  async cari() {
    this.loading = true;
    this.detailData = "";
    this.detailDataByHID = "";
    try {
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/julatHarga/getData`,{
          pusingan : this.pusingan,
          kodItem : this.kodItem
        });

        var dataz = res.data.data;
        this.dataJulatHarga = dataz;
        this.loading = false;
      
    } catch (error) {
      this.errorDialog = true;
      setTimeout(() => (this.errorDialog = false), 2000);
      this.errMessage = "getData : " + error;
    }

  },

  handleClick(data){
    this.detailData = data;
    this.getDetailDataByHID(data);

  },

  convertTarikh(data){
    if(data != undefined){
      var convertDate =  new Date(data);
      return convertDate.toISOString().split('T')[0]; 
    } 
  },
  

  async getDetailDataByHID(data){
    this.loading = true;
    try {
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/julatHarga/getDetailDataByHID`,{
          detailData : data
        });

        var dataz = res.data.data;
        this.detailDataByHID = dataz;
        this.loading = false;
      
    } catch (error) {
      this.errorDialog = true;
      setTimeout(() => (this.errorDialog = false), 2000);
      this.errMessage = "getData : " + error;
    }


  }
    
   
  

  },
    watch:{
    paparnegeriexport(val){ 
      this.detailNegeri = val; 
    },
  }
};
</script>
<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin: 50px auto;
}
tr {
  background: #eee;
}

td,
th {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
  font-size: 18px;
}
</style>